import React, { ReactNode } from 'react';
import { Loader } from 'semantic-ui-react';

export function CustomerAAN(props: { aanUrl?: string }) {
  const isGenerating = props.aanUrl === 'generating';

  let content: ReactNode = 'Unable to load Adverse Action Notice PDF';
  if (isGenerating) {
    content = <Loader content="loading" active />;
  } else if (props.aanUrl) {
    content = (
      <div>
        <Loader content="loading" active />
        <iframe
          src={props.aanUrl}
          width={'100%'}
          height={'100%'}
          title={'PDF form'}
          className="pdf-iframe"
          data-testid="aan-iframe"
        />
      </div>
    );
  }

  return (
    <div className="aanPdfView">
      <h3>Upstart Offer - Applicant Denied</h3>
      <div>{content}</div>
    </div>
  );
}
